export const API_ENDPOINT_TEST = `https://kragi-api.onetwo.gg`;
export const API_ENDPOINT_PROD = `https://kragi-api.onetwo.gg`;
// export const API_ENDPOINT_PROD = `https://api.shlemkragi.redbull.com/`;

export const API_ENDPOINT = API_ENDPOINT_PROD;

export const WEBSOCKET_ENDPOINT_TEST = "//kragi-ws.onetwo.gg";
export const WEBSOCKET_ENDPOINT_PROD = "//kragi-ws.onetwo.gg";

export const WEBSOCKET_ENDPOINT = WEBSOCKET_ENDPOINT_PROD;

export const rbAuthToken = "p9829ikik";
